import React, { Component } from "react";
import classnames from "classnames";

import { Icon, IconName } from "@formant/ui/component/common/Icon";

import { Button } from "../Button";
import * as styles from "./TabButton.scss";

export interface ITabButtonProps {
    mode: "top" | "side";
    name: string;
    icon?: IconName;
    selected: boolean;
    onSelected: (name: string) => void;
    validationError: boolean;
}

export class TabButton extends Component<ITabButtonProps> {
    public render() {
        const { mode, name, icon, selected, validationError } = this.props;
        return (
            <Button
                className={classnames(
                    styles["tab-button"],
                    styles.button,
                    selected && styles.selected,
                    !selected && validationError && styles["validation-error"],
                    styles[mode],
                )}
                onClicked={this.onClicked}
                data-testid={`tab-button-${name}`}
            >
                {icon && <Icon name={icon} />}
                {name}
            </Button>
        );
    }

    private onClicked = () => {
        const { name, onSelected } = this.props;
        onSelected(name);
    };
}
